import { createFileRoute } from "@tanstack/react-router";
import { SisuSimulatorRoot } from "@/components/sisu-simulator/root";
import { sisuSimulatorSearchSchema } from "@/schemas/sisu";

export const Route = createFileRoute("/_app/simulador-sisu")({
	validateSearch: (search) => sisuSimulatorSearchSchema.parse(search || {}),
	component: SisuSimulatorPage,
});

function SisuSimulatorPage() {
	const search = Route.useSearch();

	return (
		<div className="w-full">
			<SisuSimulatorRoot prefilledGrades={search} />
		</div>
	);
}
